import { useState } from "react";

const SITE = "https://ca-ccw-training.preview.emergentagent.com";

const SNIPPETS = {
  iframe: `<iframe src="${SITE}" width="100%" height="900" style="border:0;border-radius:6px;" title="CA CCW Online Training"></iframe>`,
  hero: `<a href="${SITE}/register" style="display:inline-block;background:#0f172a;color:#fff;padding:14px 28px;border-radius:4px;font-family:system-ui,sans-serif;font-weight:600;text-decoration:none;">Enroll in CA CCW Online Training →</a>`,
  badge: `<a href="${SITE}" style="display:inline-flex;align-items:center;gap:10px;border:1px solid #cbd5e1;padding:10px 16px;border-radius:4px;font-family:system-ui,sans-serif;color:#0f172a;text-decoration:none;"><img src="${SITE}/logo.jpg" height="32"/><span><strong>Blue Line</strong> · CA CCW Online Training</span></a>`,
};

export default function EmbedKit() {
  const [copied, setCopied] = useState("");
  const copy = (k) => { navigator.clipboard.writeText(SNIPPETS[k]); setCopied(k); setTimeout(() => setCopied(""), 1500); };
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Marketing</div>
      <h1 className="text-4xl font-bold tracking-tight text-slate-900 mt-2" style={{ fontFamily: "Chivo, sans-serif" }}>
        Embed & Share Kit
      </h1>
      <p className="text-slate-600 mt-3 text-sm">Copy any of the snippets below and paste them into your existing Blue Line Security Consulting website to funnel visitors into the CCW course.</p>
      {[
        { k: "iframe", t: "Full-page iframe embed", d: "Drop this anywhere — renders the entire training site inside your page." },
        { k: "hero", t: "Hero call-to-action button", d: "A single button that links to the enrollment page. Use on your homepage hero." },
        { k: "badge", t: "Logo + label badge", d: "A small badge with your logo + course title. Good for sidebars and footers." },
      ].map(({ k, t, d }) => (
        <div key={k} className="mt-8 bg-white border border-slate-200 rounded-sm p-5">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: "Chivo, sans-serif" }}>{t}</h2>
              <p className="text-xs text-slate-500 mt-1">{d}</p>
            </div>
            <button data-testid={`copy-${k}`} onClick={() => copy(k)} className="bg-slate-900 hover:bg-slate-800 text-white px-4 py-2 rounded-sm font-medium text-sm">
              {copied === k ? "Copied!" : "Copy snippet"}
            </button>
          </div>
          <pre className="mt-4 bg-slate-50 border border-slate-200 rounded-sm p-3 text-xs text-slate-700 overflow-x-auto whitespace-pre-wrap font-mono">{SNIPPETS[k]}</pre>
        </div>
      ))}
    </div>
  );
}
